import React from 'react';
import SectionTitle from '../common/SectionTitle';
import TestimonialCard from '../common/TestimonialCard';

const TestimonialsSection: React.FC = () => {
  const testimonials = [
    {
      name: 'Priya Sharma',
      college: 'Sourabh College of Veterinary Science',
      imageUrl: 'https://images.pexels.com/photos/3763188/pexels-photo-3763188.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
      testimonial: 'The guidance provided by VetEdu Consultants was invaluable. Their personalized approach and in-depth knowledge of the admission process helped me secure a seat at my dream college.'
    },
    {
      name: 'Rahul Singh',
      college: 'RPS College of Veterinary Science',
      imageUrl: 'https://images.pexels.com/photos/1681010/pexels-photo-1681010.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
      testimonial: 'I was confused about the college selection process, but the team at VetEdu made it simple. Their step-by-step guidance and continuous support made all the difference.'
    },
    {
      name: 'Ananya Patel',
      college: 'Abhilashi Veterinary College',
      imageUrl: 'https://images.pexels.com/photos/3771089/pexels-photo-3771089.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
      testimonial: 'From NEET preparation to final admission, VetEdu was with me every step of the way. Their expertise in the veterinary education field is unmatched. Highly recommended!'
    }
  ];

  return (
    <section className="section">
      <div className="container-custom">
        <SectionTitle 
          title="Success Stories" 
          subtitle="Hear from our students who successfully secured admissions in top veterinary colleges."
        />
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <TestimonialCard 
              key={index}
              name={testimonial.name}
              college={testimonial.college}
              imageUrl={testimonial.imageUrl}
              testimonial={testimonial.testimonial}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;